export const courses: { [key: string]: string } = {
  diom: "Developing and Implementing an Outward Mindset",
  lom: "Living with an Outward Mindset",
  // of: "Outward Fundamentals",
  oi: "Outward Inclusion",
  ol: "Outward Leadership",
  omed: "Outward Mindset in Education",
  omps: "Outward Mindset in Public Safety",
  omo: "Outward Mindset Online",
  op: "Outward Performance",
  oe: "Overcoming Extremism",
  theo: "Theo",
}

export function getCourseAbbreviatedNameForTheWorkbooks(course: string): string {
  switch (course) {
    case "outwardleadership":
      return "ol"
    case "outwardinclusion":
      return "oi"
    case "outwardperformance":
      return "op"
    default:
      return course.toLowerCase()
  }
}
